import { FeatureComponent } from "../../../types/components.interface"

const isBlankFeature = (featureComponent: FeatureComponent) => {
  return featureComponent.text.childMarkdownRemark.html.includes("$BLANK$")
}

export default isBlankFeature
